import * as React from "react";
import { createDragDropManager } from "dnd-core";
export var DndContext = React.createContext({
  dragDropManager: void 0
});
export function createDndContext(backend, context, options, debugMode) {
  return {
    dragDropManager: createDragDropManager(backend, context, options, debugMode)
  };
}
